import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageWithFallback',
  props: {
  fallback: {
    type: String,
    default: '/projects/dw/gmf/assets/images/preview.jpg?v2025',
  },
  src: {
    type: String,
    required: true,
  }
},
  setup(__props) {


const props = __props;

const computedSource = ref(`${props.src}?nocache=${(new Date()).getMinutes()}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: computedSource.value,
    onError: _cache[0] || (_cache[0] = ($event: any) => (computedSource.value = __props.fallback))
  }, null, 40, _hoisted_1))
}
}

})